import { CSSProperties, FC } from 'react';
import { useTheme } from '@mui/material/styles';

import logo from 'assets/images/halog-logo-color.png';
import logoDarkMode from 'assets/images/halog-logo-text-dark-theme.png';
import { Box } from '@mui/system';

const Logo: FC = () => {
    const theme = useTheme();
    return (
        <Box
            component="img"
            src={theme.palette.mode === 'dark' ? logoDarkMode : logo}
            alt="Halog"
            sx={{
                width: {
                    xs: 120,
                    md: 180
                },
                display: 'block'
            }}
        />
    );
};
export default Logo;
